const AllProductData = (productData) => {
  const finalHomeProducts = [];

  Object.keys(productData).forEach((item) => {
    finalHomeProducts.push(productData[item]);
  });

  return finalHomeProducts;
};

export const finalHomeProducts = AllProductData(window.home4Products || {});

const AllZhHomeAdvData = (zhHomeAdvData) => {
  const finalZhHomeAdv = {
    MainBannerAdv: [], // 首頁大banner
    // // 目前沒用footer這個版位, 但怕後續需要
    // Footer: {},
  };

  const newIndexData = zhHomeAdvData;

  Object.keys(newIndexData).forEach((item, index) => {
    console.log(index, 'zhHomeAdvData==index');
    if (item.indexOf('MB1') !== -1) {
      // 首頁大banner
      finalZhHomeAdv.MainBannerAdv = newIndexData[item];
      delete newIndexData.item;
    } else {
      finalZhHomeAdv[item] = newIndexData[item];
    }
  });

  return finalZhHomeAdv;
};

export const finalZhHomeAdvData = AllZhHomeAdvData(window.zhHomeAdv || {});
